import { render, staticRenderFns } from "./businessReceiptList.vue?vue&type=template&id=587a9b25"
import script from "./businessReceiptList.vue?vue&type=script&lang=js"
export * from "./businessReceiptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports